import { HashtagIcon } from '@heroicons/react/solid'
import React from 'react'
import { Subtitle } from 'src/components/Typography'
import { classes } from 'src/utils'

type Props = {
  id: string
  question: string
  children: React.ReactNode
  isActive: boolean
  withNavbar?: boolean
}

export function FAQ(props: Props) {
  const ref = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (props.isActive) {
      ref.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [props.isActive])

  return (
    <div
      className={classes(
        'relative flex flex-col w-full mt-4 mb-8',
        props.withNavbar ? 'scroll-mt-32' : 'scroll-mt-20',
      )}
      id={props.question}
      ref={ref}
    >
      <a
        href={`#${props.id}` as const}
        className="flex flex-row items-center w-full rounded cursor-pointer group hover:bg-slate-50 active:bg-slate-100"
      >
        <HashtagIcon
          className={classes(
            'w-4 h-4 mx-2',
            props.isActive ? 'fill-theme-500' : 'fill-slate-300',
          )}
        />

        <Subtitle label={props.question} />
      </a>

      <div className="ml-8 text-base text-slate-700">{props.children}</div>
    </div>
  )
}
